export const PRECONNECT_CROWDRIFF = {
  rel: 'preconnect',
  href: 'https://s3.amazonaws.com',
  crossorigin: true,
  hid: 'crowdriff',
}

export const PRECONNECT_ROUNDSHOT = {
  rel: 'preconnect',
  href: 'https://backend.roundshot.com',
  crossorigin: true,
  hid: 'roundshot',
}

export const PRECONNECT_TOMAS = {
  rel: 'preconnect',
  href: 'https://twebshop.tomas-travel.com',
  crossorigin: true,
  hid: 'tomas',
}

export const PAGE_TITLE_SUFFIX = 'zuerich.com'
